import Icon from 'veui/components/Icon'
import { IconCamera } from 'dls-icons-vue'

Icon.register('camera', IconCamera)
